var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"particles-container",attrs:{"id":"particles-js"}})
}
var staticRenderFns = []

export { render, staticRenderFns }